import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { adminLogin } from "../../../Store/Admin/Login/LoginSlice";
import toast from "react-hot-toast";

const Login = () => {
  const [login, setLogin] = useState({
    email: "",
    password: "",
    pwdShow: true,
  });
  const [disable, setDisable] = useState(false);
  const [error, setError] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (localStorage.getItem("PAY_ADMIN_TOKEN") !== null) {
      navigate("/admin/dashboard");
      toast.success("Already Logged In");
    }
  }, []);

  const handleChange = (e) => {
    setLogin({ ...login, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validation()) {
      setDisable(true);

      dispatch(adminLogin({ email: login.email, password: login.password }))
        .then((response) => {
          // console.log(response, '@@@');
          if (!response?.error) {
            navigate("/admin/dashboard");
          }
          setDisable(false);
          // setLogin({ email: "", password: "" });
        })
        .catch((error) => {
          console.log(error, "error");
          setDisable(false);
        });
    }
  };

  const validation = () => {
    var isValid = true;
    let err = {};

    if (!login.email) {
      isValid = false;
      err["email_err"] = "Please enter email";
    }

    if (!login.password) {
      isValid = false;
      err["password_err"] = "Please enter password";
    }

    setError(err);
    return isValid;
  };

  return (
    <>
      <div className="account-page login-page">
        <div className="bgImg-Page"></div>
        <div className="container">
          <div className="row login-Row">
            <div className="col-md-6 col-lg-5 col-sm-12">
              <div className="card p-3 cardTransparent">
                <div className="logoLogin d-flex align-center justify-content-center mb-3"></div>
                <h3 className="account-title mt-4 mb-4 text-center">
                  Admin Login
                </h3>

                <form className="row g-3" onSubmit={handleSubmit}>
                  <div className="col-md-12">
                    <label for="inputEmail4" className="form-label">
                      Email Address
                    </label>
                    <input
                      className="form-control"
                      onChange={handleChange}
                      name="email"
                      type="text"
                      value={login.email}
                    />
                    <div className="error">{error.email_err}</div>
                  </div>

                  <div className="col-md-12 position-relative">
                    <label for="password" className="form-label">
                      Password
                    </label>
                    <input
                      className="form-control position-relative"
                      type={login.pwdShow ? "password" : "text"}
                      value={login.password}
                      onChange={handleChange}
                      name="password"
                      id="password"
                    />
                    {login.pwdShow ? (
                      <div
                        className="icon-Show"
                        onClick={() => {
                          setLogin({ ...login, pwdShow: false });
                        }}
                      >
                        <i className="fa-solid fa-eye" />
                      </div>
                    ) : (
                      <div
                        className="icon-Show"
                        onClick={() => setLogin({ ...login, pwdShow: true })}
                      >
                        <i className="fa-solid fa-eye-slash" />{" "}
                      </div>
                    )}
                    <div className="error">{error.password_err}</div>
                  </div>

                  {/* <div className="forgotPass justify-content-end d-flex mt-2">
                    <span>
                      {" "}
                      <Link to="/admin/forget-password">Forgot Password?</Link>
                    </span>
                  </div> */}

                  <div className="input-block mt-4 text-center">
                    <button
                      className="btn btn-primary account-btn w-100"
                      type="submit"
                      disabled={disable}
                    >
                      {disable ? "Processing..." : "Sign in"}
                    </button>
                  </div>

                  <div className="account-footer mt-0">
                    <p className="text-center">
                      <span>
                        {" "}
                        <Link to="/">Back</Link>
                      </span>
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
